import {
  useConnectedGithubOrgsNonSuspense,
  useOrgUrlSync,
} from "@/hooks/useConnectedGithubOrgs";
import { GithubWebOriginContext } from "@/hooks/useGithubWebOrigin";
import { ReactNode } from "react";

interface OrgUrlSyncProviderProps {
  children: ReactNode;
}

// This component wraps pages that need URL-based org sync
// It should only be used on pages that have [org] in their route
export function OrgUrlSyncProvider({ children }: OrgUrlSyncProviderProps) {
  // Initialize URL sync for org switching
  useOrgUrlSync();
  const { connectedGithubOrgs } = useConnectedGithubOrgsNonSuspense();

  return (
    <GithubWebOriginContext.Provider
      value={connectedGithubOrgs?.github_web_url ?? null}
    >
      {children}
    </GithubWebOriginContext.Provider>
  );
}
